module.exports = __webpack_public_path__ + "static/default-bc7ceaf7925f5b47adee06511c3120ee.jpg";